var notificationTypeTitles = {
    Info: "Information",
    Error: "Error",
    Warning: "Warning",
    Success: "Success",
};
export var notificationTypeStyle = {
    Info: "bg-blue-500 flex rounded-lg p-2",
    Error: "bg-red-500 flex rounded-lg p-2",
    Warning: "bg-amber-500 flex rounded-lg p-2",
    Success: "bg-green-500 flex rounded-lg p-2",
};
export var getNotificationTypeTitle = function (notificationType) { return notificationTypeTitles[notificationType]; };
